<script setup lang="ts">
defineOptions({
  name: 'Kursus'
})
const title = 'Kursus Online di Kognisi - Belajar Fleksibel dan Berkualitas'
const keywords =
  'kursus online, belajar online, pelatihan digital, teknologi, bisnis, pengembangan diri, kognisi kursus'
const description =
  'Temukan kursus online terbaik di Kognisi. Belajar dengan fleksibel dari topik seperti teknologi, bisnis, hingga pengembangan diri. Tingkatkan skill Anda hari ini!'
const url = 'https://kognisi.id/kursus'

useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Kursus Online di Kognisi',
  description:
    'Temukan berbagai kursus online berkualitas di Kognisi. Pilih kursus sesuai kebutuhanmu untuk meningkatkan keterampilan.',
  url: 'https://kognisi.id/kursus/',
  numberOfItems: 3,
  itemListElement: [
    {
      '@type': 'Course',
      name: 'MEMBUAT STORYTELLING SESUAI KAIDAH JURNALISTIK UNTUK KONTEN KREATOR',
      description:
        'Kemunculan berbagai platform baru dan meningkatnya jumlah profesi yang mengutamakan pemanfaatan cerita menuntut kita mengembangkan kemampuan storytelling.',
      provider: {
        '@type': 'Organization',
        name: 'Kognisi',
        url: 'https://kognisi.id'
      },
      url: 'https://kognisi.id/kursus/membuat-storytelling-sesuai-kaidah-jurnalistik-untuk-konten-kreator',
      educationalLevel: 'Pemula',
      courseMode: 'Online',
      instructor: {
        '@type': 'Person',
        name: 'Wisnu Nugroho',
        description: 'Editor In Chief Kompas.com'
      }
    },
    {
      '@type': 'Course',
      name: 'MENULIS NASKAH BERITA BAGI CALON WARTAWAN',
      description:
        'Kemunculan berbagai platform publikasi baru dan meningkatnya jumlah profesi yang mengutamakan kemampuan menulis menuntut kita mengembangkan kemampuan tulis-menulis.',
      provider: {
        '@type': 'Organization',
        name: 'Kognisi',
        url: 'https://kognisi.id'
      },
      url: 'https://kognisi.id/kursus/menulis-naskah-berita-bagi-calon-wartawan',
      educationalLevel: 'Pemula',
      courseMode: 'Online',
      instructor: {
        '@type': 'Person',
        name: 'Heru Margianto',
        description: 'Managing Editor Kompas.com'
      }
    },
    {
      '@type': 'Course',
      name: 'MENCIPTAKAN KONTEN KREATIF DAN MEMPERLUAS JANGKAUAN BISNIS MELALUI BLOG',
      description:
        'Kita semua tentu menyadari bahwa saat ini peluang untuk berekspresi dan berkarya di internet, khususnya di berbagai media online sudah semakin luas.',
      provider: {
        '@type': 'Organization',
        name: 'Kognisi',
        url: 'https://kognisi.id'
      },
      url: 'https://kognisi.id/kursus/menciptakan-konten-kreatif-dan-memperluas-jangkauan-bisnis-melalui-blog',
      educationalLevel: 'Pemula',
      courseMode: 'Online',
      instructor: {
        '@type': 'Person',
        name: 'Nurulloh',
        description: 'Chief Operating Officer (COO) Kompasiana'
      }
    }
  ]
}))

useHead({
  link: [{ rel: 'canonical', href: url }]
})

useSeoMeta({
  title,
  keywords,
  description,
  ogUrl: url,
  ogTitle: title,
  ogDescription: description,
  twitterTitle: title,
  twitterDescription: description,
  robots: 'index, follow'
})
</script>

<template>
  <NuxtLayout name="home">
    <NuxtLoadingIndicator />
    <LazyModulesKursusMainOrganismsKursusCatalgue />
  </NuxtLayout>
</template>
